import { isMobile } from "react-device-detect";

import {
  LIVE_PRICE_MOBILE_COLUMNS,
  LIVE_PRICE_DESKTOP_COLUMNS_TOMAN,
  LIVE_PRICE_DESKTOP_COLUMNS_ALL_COIN,
  LIVE_PRICE_DESKTOP_COLUMNS_TETHER,
  RIALS_FEES_DESKTOP_COLUMNS,
  RIALS_FEES_MOBILE_COLUMNS,
} from "../fixtureData/tableColumnsProprty";
export const LIVE_PRICE_COLUMNS_TOMAN = isMobile
  ? LIVE_PRICE_MOBILE_COLUMNS
  : LIVE_PRICE_DESKTOP_COLUMNS_TOMAN;
export const LIVE_PRICE_COLUMNS_TETHER = isMobile
  ? LIVE_PRICE_MOBILE_COLUMNS
  : LIVE_PRICE_DESKTOP_COLUMNS_TETHER;
export const LIVE_PRICE_COLUMNS_ALL_COIN = isMobile
  ? LIVE_PRICE_MOBILE_COLUMNS
  : LIVE_PRICE_DESKTOP_COLUMNS_ALL_COIN;
export const RIALS_FEES_COLUMNS = isMobile
  ? RIALS_FEES_MOBILE_COLUMNS
  : RIALS_FEES_DESKTOP_COLUMNS;
